<template>
  <div>
    <div class="handle-box">
      <el-form ref="queryForm" :model="queryForm" label-position="right" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="用户账号" prop="emplid">
                  <el-input class="handle-input" v-model="queryForm.emplid" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用户名称" prop="name">
                  <el-input class="handle-input" v-model="queryForm.name" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="供应商编码" prop="supplierCode">
                  <el-input class="handle-input" v-model="queryForm.supplierCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="供应商名称" prop="supplierName">
                  <el-input class="handle-input" v-model="queryForm.supplierName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="手机" prop="phone">
                    <el-input class="handle-input" v-model="queryForm.phone" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="邮箱" prop="email">
                    <el-input class="handle-input" v-model="queryForm.email" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
          <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <el-row class="action-btn-row">
      <el-button size="mini" class='btn' type="primary" @click="onConfirm">确定</el-button>
      <el-button size="mini" class='btn' @click="onCancel">取消</el-button>
    </el-row>
    <el-table :data="dataList" @selection-change="handleSelectionChange" ref="dataList" border highlight-current-row>
      <el-table-column width="55px" type="selection" :selectable="(row)=>!emplids.includes(row.emplid)" align="center"></el-table-column>
      <el-table-column label="用户账号" prop="emplid" show-overflow-tooltip min-width="100px"></el-table-column>
      <el-table-column label="用户名称" prop="name" show-overflow-tooltip min-width="160px"></el-table-column>
      <el-table-column label="供应商编码" prop="supplierCode" show-overflow-tooltip min-width="100px"></el-table-column>
      <el-table-column label="供应商名称" prop="supplierName" show-overflow-tooltip min-width="160px"></el-table-column>
      <el-table-column label="手机" prop="phone" show-overflow-tooltip min-width="100px"></el-table-column>
      <el-table-column label="邮箱" prop="email" show-overflow-tooltip min-width="200px"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryForm.pageNum" :page-sizes="pageSizeList" :page-size="queryForm.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import paginationMixin from '@/mixins/pagitionMixin';
import report from "@/api/sensory/processReport";
export default {
  name: 'RaterDialog',
  mixins: [paginationMixin],
  props: ['emplidLists'],
  data() {
    return {
      isShow: false,
      multipleSelection: [],
      queryForm: {
        emplid: "",
        name: "",
        supplierCode: "",
        supplierName: "",
        phone: "",
        email: "",
        pageSize: 15,
        pageNum: 1,
      },
      totalCount: 0,
      pages: 1,
      dataList: [],
      emplids: []
    }
  },
  watch: {
    emplidLists: {
      handler(newVal, oldVal) {
        console.log('newVal :', newVal);
        if (newVal) {
          this.emplids = JSON.parse(newVal)
        }
      },
      immediate: true
    }
  },
  created() {
    this.queryData()
  },
  methods: {
    queryData() {
      report.querySensoryRatersCandidates(this.queryForm).then(res => {
        console.log("🚀 ~ querySensoryRatersCandidates ~ res:", res)
        if (res) {
          this.dataList = res.resultData
          this.totalCount = res.totalCount
        }
      })
    },
    onConfirm() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请选择用户",
          type: "warning"
        })
        return
      }
      report.addSensoryRaters(this.multipleSelection).then(res => {
        console.log("🚀 ~ addSensoryRaters ~ res:", res)
        if (res) {
          this.$message({
            message: "添加成功",
            type: "success"
          })
          this.onCancel()
        }
      })
    },
    onCancel() {
      this.emplids = []
      this.onReset()
      this.$emit("closeRaterDialog")
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onDelItem(item, index) {

    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val
      this.queryData()
    },
    onSearch() {
      this.queryForm.pageNum = 1;
      this.queryData()
    },
    onReset() {
      this.queryForm = {
        emplid: "",
        name: "",
        supplierCode: "",
        supplierName: "",
        phone: "",
        email: "",
        pageSize: 15,
        pageNum: 1,
      }
      this.queryData()
    },
  }
}
</script>
